<template>
  <g class="bubbles">
    <!-- class visible let you see elements on hover -->
    <!-- This is the main circle (visible) and the second circle is the center one (only hover) -->
    <circle
      v-for="(datum, index) in d"
      :class="[
        'bubble',
        { hovered: index === scatterIndex },
        { notHovered: scatterIndex !== index && scatterIndex !== null },
      ]"
      :id="'one-' + index"
      :key="'bubble-' + index"
      :cx="p.scaleX(datum[c.xAxis])"
      :cy="p.scaleY(datum[serie.key])"
      :r="p.scaleR(datum.size)"
      @mouseenter="changeOver(index, p.scaleR(datum.size))"
      @mouseout="changeOver(null, null)"
    />
    <circle
      v-for="(datum, index) in d"
      :class="['center-circle', { visible: scatterIndex === index }]"
      :key="'center-circle-' + index"
      :cx="p.scaleX(datum[c.xAxis])"
      :cy="p.scaleY(datum[serie.key])"
      @mouseenter="changeOver(index, p.scaleR(datum.size))"
      r="2"
      fill="var(--primary-yellow)"
    ></circle>
  </g>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import wrap from "../../charts/mixins/wrap";

export default {
  props: ["p", "c", "d", "serie", "globalIndex"],
  mixins: [wrap],
  data() {
    return {
      heightTooltip: null,
    };
  },
  methods: {
    computedWidth(size, label) {
      const sizeWidth = this.measureText(size, 16);
      const labelWidth = this.measureText(label, 16);
      if (labelWidth > sizeWidth) {
        return labelWidth + "px";
      } else {
        return sizeWidth + "px";
      }
    },
    changeOver(index, height) {
      this.setScatterIndex(index);
      this.heightTooltip = height;
    },
    ...mapActions({
      setScatterIndex: "ui/setScatterIndex",
    }),
  },
  computed: {
    ...mapGetters({ scatterIndex: "ui/scatterIndex" }),
  },
};
</script>

<style lang="scss" scoped>
.bubbles {
  & > .center-circle {
    opacity: 0;
    visibility: hidden;
  }

  .bubble {
    stroke: var(--source-color-dark);
    stroke-width: toRem(1);
    fill: $white_02;
    transition: stroke 0.3s ease, fill 0.3s ease;

    &.hovered {
      stroke: var(--primary-yellow);

      & ~ .visible {
        opacity: 1;
        visibility: visible;
      }
    }

    &.notHovered {
      fill: rgba(255, 255, 255, 0.05);
    }
  }
}
</style>
